import { QRCodeSVG } from "qrcode.react";
import "./review-qr.css";

function safeReviewUrl(value: string) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.toString() : "";
  } catch {
    return "";
  }
}

export function ReviewQrCode({
  url,
  label = "Scanner pour donner un avis Google",
  downloadable = false,
}: {
  url: string;
  label?: string;
  downloadable?: boolean;
}) {
  const safeUrl = safeReviewUrl(url);
  if (!safeUrl) return null;

  function downloadSvg() {
    const svg = document.querySelector<SVGElement>(
      `[data-review-qr="${CSS.escape(safeUrl)}"]`,
    );
    if (!svg) return;
    const source = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = "ard-manager-avis-google.svg";
    link.click();
    URL.revokeObjectURL(href);
  }

  return (
    <figure className="review-qr-card">
      <QRCodeSVG
        value={safeUrl}
        size={184}
        level="M"
        marginSize={4}
        bgColor="#ffffff"
        fgColor="#111111"
        aria-label={label}
        data-review-qr={safeUrl}
      />
      <figcaption>
        <strong>{label}</strong>
        <small>QR généré localement par ARD Manager, sans service tiers.</small>
      </figcaption>
      {downloadable && (
        <button className="secondary compact" type="button" onClick={downloadSvg}>
          Télécharger le QR en SVG
        </button>
      )}
    </figure>
  );
}
